import { SITE_URL } from './SEO'

/**
 * Organization + TravelAgency schema — site-wide.
 */
export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': ['TravelAgency', 'LocalBusiness'],
  '@id': `${SITE_URL}/#organization`,
  name: 'Himachal Yatra',
  url: SITE_URL,
  logo: `${SITE_URL}/static/logo.svg`,
  image: `${SITE_URL}/static/logo.svg`,
  description:
    'Premier travel booking platform for Himachal Pradesh tours, adventure activities, hotels, and travel services.',
  foundingDate: '2024',
  telephone: '+91-7418100009',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'H No 1, Shilon Filling Station',
    addressLocality: 'Shimla',
    addressRegion: 'Himachal Pradesh',
    postalCode: '171012',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '31.1048',
    longitude: '77.1734',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-7418100009',
    contactType: 'customer service',
    availableLanguage: ['English', 'Hindi'],
    areaServed: 'IN',
  },
  areaServed: {
    '@type': 'State',
    name: 'Himachal Pradesh',
  },
  priceRange: '₹₹-₹₹₹',
}

/**
 * WebSite schema with SearchAction — enables sitelinks search box in Google.
 */
export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Himachal Yatra',
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/tours?search={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
}

/**
 * Generate TouristTrip schema for a tour.
 */
export const generateTourSchema = (tour) => ({
  '@context': 'https://schema.org',
  '@type': 'TouristTrip',
  name: tour.name || tour.title,
  description: tour.description,
  touristType: 'Adventure Traveler',
  image: tour.image_url || tour.images?.[0],
  offers: {
    '@type': 'Offer',
    price: String(tour.price || 0),
    priceCurrency: 'INR',
    availability: 'https://schema.org/InStock',
    url: `${SITE_URL}/tours/${tour.id}`,
  },
  ...(tour.average_rating && {
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: String(tour.average_rating),
      reviewCount: String(tour.review_count || 1),
      bestRating: '5',
    },
  }),
  provider: {
    '@type': 'TravelAgency',
    name: 'Himachal Yatra',
    url: SITE_URL,
  },
})

/**
 * Generate Product schema for a service.
 */
export const generateServiceSchema = (service) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: service.name || service.title,
  description: service.description,
  image: service.image_url,
  offers: {
    '@type': 'Offer',
    price: String(service.price || 0),
    priceCurrency: 'INR',
    availability: 'https://schema.org/InStock',
  },
  provider: {
    '@type': 'TravelAgency',
    name: 'Himachal Yatra',
  },
})

/**
 * Generate BreadcrumbList schema.
 */
export const generateBreadcrumbs = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
})

/**
 * Generate FAQPage schema.
 */
export const generateFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
})
